import { Text } from '@lmc/ui-kit/src/general'
import { capitalize } from 'lodash'
import EventIcon from 'screens/Rostering/RotaBuilder/common/components/EventIcon'
import styled from 'styled-components'
import { RotaInstanceStatus } from 'screens/Rostering/types'

type EventCountProps = {
  type: string
  count: number
}

export function getRotaInstanceStatus(status: string): RotaInstanceStatus {
  const normalizedStatus = status
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .toUpperCase()
    .replace(' ', '_')

  return RotaInstanceStatus[normalizedStatus as keyof typeof RotaInstanceStatus]
}

const EventCount = ({ type, count }: EventCountProps) => {
  const status = getRotaInstanceStatus(type)

  return (
    <Container>
      <EventIcon status={status} />
      <CountContainer>
        <Text>{count}</Text>
      </CountContainer>
      <Text>{capitalize(type)}</Text>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 6px;
`
const CountContainer = styled.div`
  width: 28px;
`

export default EventCount
